import { render } from "./TopLeftMargin.vue?vue&type=template&id=84881cfa&scoped=true"
import script from "./TopLeftMargin.vue?vue&type=script&lang=js"
export * from "./TopLeftMargin.vue?vue&type=script&lang=js"

import "./TopLeftMargin.vue?vue&type=style&index=0&id=84881cfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84881cfa"]])

export default __exports__